//second hand first roll
export const response8 = {
	"Payload": {
		"Match": {
			"Id": "tutorial",
			"Version": 1,
			"CreatorId": 22,
			"Type": "ch",
			"State": "pr",
			"BlockingType": "alternate",
			"PlayerCount": 2,
			"ActiveRoundNum": 2,
			"ActiveUserId": 22,
			"RoundCount": 9,
			"CreatedTime": 1582666798,
			"UpdatedTime": 1582666798,
			"InvitedTime": 0,
			"CompletedTime": 0,
			"CanAcceptChallenge": false,
			"IsStartHand": false,
			"CanRollDice": true,
			"CanApplyFreeroll": false,
			"CanApplyHandReset": false,
			"CanKeepHand": false,
			"CanResignMatch": true,
			"UserAcceptedTime": 1582666798,
			"UserResignedTime": 0,
			"UserCurrentRound": 2,
			"UserActiveTime": 1582666798,
			"UserNudgedTime": 0,
			"UserNudgeSentTime": 0,
			"UserFreeRolls": 0,
			"UserFreeRollsUsed": 0,
			"UserState": "pl",
			"UserBaseScore": 0,
			"UserFinalScore": 0,
			"UserOutcome": 0,
			"Opponents": [{
				"UserId": 92,
				"Username": "Ava",
				"DisplayName": "Ava",
				"ImageUrl": "/assets/tutorial/bots_ava_2.png",
				"AcceptedTime": 0,
				"ResignedTime": 0,
				"CurrentRound": 0,
				"ActiveTime": 0,
				"NudgedTime": 0,
				"NudgeSentTime": 0,
				"State": "pr",
				"TotalScore": 0,
				"Outcome": 0,
				"IsBot": true,
				"MatchRounds": []
			}],
			"Rounds": [{
				"RoundNum": 1,
				"Rolls": 3,
				"State": "pl",
				"TargetHand": 3,
				"TargetHandPoints": 1,
				"TargetHandBonusPoints": 1,
				"WinnerTakeAll": false,
				"SectionBonus": 0,
				"SectionEnd": false
			}, {
				"RoundNum": 2,
				"Rolls": 3,
				"State": "pl",
				"TargetHand": 4,
				"TargetHandPoints": 2,
				"TargetHandBonusPoints": 1,
				"WinnerTakeAll": false,
				"SectionBonus": 0,
				"SectionEnd": false
			}, {
				"RoundNum": 3,
				"Rolls": 3,
				"State": "ns",
				"TargetHand": 5,
				"TargetHandPoints": 3,
				"TargetHandBonusPoints": 1,
				"WinnerTakeAll": false,
				"SectionBonus": 0,
				"SectionEnd": true
			}, {
				"RoundNum": 4,
				"Rolls": 3,
				"State": "ns",
				"TargetHand": 6,
				"TargetHandPoints": 4,
				"TargetHandBonusPoints": 2,
				"WinnerTakeAll": false,
				"SectionBonus": 0,
				"SectionEnd": false
			}, {
				"RoundNum": 5,
				"Rolls": 3,
				"State": "ns",
				"TargetHand": 7,
				"TargetHandPoints": 5,
				"TargetHandBonusPoints": 2,
				"WinnerTakeAll": false,
				"SectionBonus": 0,
				"SectionEnd": false
			}, {
				"RoundNum": 6,
				"Rolls": 3,
				"State": "ns",
				"TargetHand": 8,
				"TargetHandPoints": 6,
				"TargetHandBonusPoints": 2,
				"WinnerTakeAll": false,
				"SectionBonus": 0,
				"SectionEnd": true
			}, {
				"RoundNum": 7,
				"Rolls": 3,
				"State": "ns",
				"TargetHand": 11,
				"TargetHandPoints": 7,
				"TargetHandBonusPoints": 4,
				"WinnerTakeAll": false,
				"SectionBonus": 0,
				"SectionEnd": false
			}, {
				"RoundNum": 8,
				"Rolls": 3,
				"State": "ns",
				"TargetHand": 12,
				"TargetHandPoints": 8,
				"TargetHandBonusPoints": 4,
				"WinnerTakeAll": false,
				"SectionBonus": 0,
				"SectionEnd": false
			}, {
				"RoundNum": 9,
				"Rolls": 3,
				"State": "ns",
				"TargetHand": 999,
				"TargetHandPoints": 9,
				"TargetHandBonusPoints": 4,
				"WinnerTakeAll": false,
				"SectionBonus": 0,
				"SectionEnd": false
			}],
			"UserMatchRounds": [{
				"RoundNum": 1,
				"RetryLimit": 1,
				"RetryNum": 0,
				"State": "co",
				"Score": 1,
				"FinalScore": 0,
				"Outcome": 0,
				"FreeRollLimit": 1,
				"FreeRollsUsed": 0,
				"FinalDiceRoll": [5, 4, 3, 2, 3, 4, 1, 5, 1],
				"FinalDiceFaces": ["9c", "6c", "2d", "Kd", "6s", "Yj", "7c", "4h", "Jc"],
				"BestHand": [3, 5, 4, 1],
				"BestHandFaces": ["Kd", "Yj", "6s", "6c"],
				"BestHandTarget": 3,
				"BestPossibleHand": false,
				"SectionBonus": 0,
				"Rolls": [{
					"RollNum": 1,
					"DiceRoll": [1, 0, 5, 5, 1, 2, 2, 3, 3],
					"DiceFaces": ["3h", "Ah", "Ks", "2s", "3c", "8s", "9h", "Ad", "Ts"],
					"Selection": [],
					"FreeRoll": false,
					"Completed": false,
					"BestHand": [1, 7, 0, 4],
					"BestHandFaces": ["Ah", "Ad", "3h", "3c"],
					"BestHandTarget": 3,
					"BestPossibleHand": false
				}, {
					"RollNum": 2,
					"DiceRoll": [4, 4, 4, 2, 1, 2, 0, 2, 4],
					"DiceFaces": ["Ac", "6c", "8c", "Kd", "3c", "8s", "Qs", "5c", "7d"],
					"Selection": [],
					"FreeRoll": false,
					"Completed": false,
					"BestHand": [],
					"BestHandFaces": [],
					"BestHandTarget": 3,
					"BestPossibleHand": false
				}, {
					"RollNum": 3,
					"DiceRoll": [5, 4, 3, 2, 3, 4, 1, 5, 1],
					"DiceFaces": ["9c", "6c", "2d", "Kd", "6s", "Yj", "7c", "4h", "Jc"],
					"Selection": [],
					"FreeRoll": false,
					"Completed": false,
					"BestHand": [3, 5, 4, 1],
					"BestHandFaces": ["Kd", "Yj", "6s", "6c"],
					"BestHandTarget": 3,
					"BestPossibleHand": false
				}]
			}, {
				"RoundNum": 2,
				"RetryLimit": 1,
				"RetryNum": 0,
				"State": "pl",
				"Score": 0,
				"FinalScore": 0,
				"Outcome": 0,
				"FreeRollLimit": 1,
				"FreeRollsUsed": 0,
				"FinalDiceRoll": [],
				"FinalDiceFaces": [],
				"BestHand": [],
				"BestHandFaces": [],
				"BestHandTarget": 4,
				"BestPossibleHand": false,
				"SectionBonus": 0,
				"Rolls": [{
					"RollNum": 1,
					"DiceRoll": [0, 4, 4, 5, 4, 1, 2, 1, 3],
					"DiceFaces": ["7s", "6c", "8c", "2s", "4d", "3d", "9h", "6d", "Ts"],
					"Selection": [],
					"FreeRoll": false,
					"Completed": false,
					"BestHand": [],
					"BestHandFaces": [],
					"BestHandTarget": 4,
					"BestPossibleHand": false
				}]
			}]
		}
	},
	"ErrorCode": 0,
	"ErrorMessage": ""
}
